export default "__VITE_ASSET__CH6m3Nv6__"